module.exports = __webpack_public_path__ + "img/haslogin.a21e0b3b.png";